import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { RenderInlineSearchCommand } from '../commands/RenderInlineSearchCommand';
import { InlineSearchCommands } from '../enums';

export class InlineSearchAppRenderEvent implements IEvent {
	public static readonly EventType = InlineSearchCommands.INLINE_SEARCH_APP_RENDER_EVENT;
	public readonly timestamp = new Date();
	public readonly eventType = InlineSearchAppRenderEvent.EventType;
	public readonly command: RenderInlineSearchCommand;

	constructor(command: RenderInlineSearchCommand) {
		this.command = command;
	}

	public static is(event: IEvent): event is InlineSearchAppRenderEvent {
		return event.eventType === InlineSearchAppRenderEvent.EventType as string;
	}

}